/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Edit_SubtitleInputs */

const cs_automation_edit_subtitle = /** @type {(inputs: Automation_Edit_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Triggery, podmínky a akce.`)
};

const en_automation_edit_subtitle = /** @type {(inputs: Automation_Edit_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Triggers, conditions and actions.`)
};

/**
* | output |
* | --- |
* | "Triggers, conditions and actions." |
*
* @param {Automation_Edit_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const automation_edit_subtitle = /** @type {((inputs?: Automation_Edit_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Edit_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_edit_subtitle(inputs)
	return cs_automation_edit_subtitle(inputs)
});